import React from 'react';
import Table from '../../common/TableOverView';
import { connect } from 'react-redux';
import memoize from 'fast-memoize';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';
import { remove } from 'lodash';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopForeignTradeByTicker;

const getHideColumns = option => {
  let hideColumnsNew = [...Const.listHideColumn];
  if (!option) {
    remove(hideColumnsNew, function(n) {
      return n === 'foreignBuyVolume';
    });
  }
  if (option === 'NetBuyVol') {
    remove(hideColumnsNew, function(n) {
      return n === 'foreignBuyVolume';
    });
  } else if (option === 'NetBuyVal') {
    remove(hideColumnsNew, function(n) {
      return n === 'foreignBuyValue';
    });
  } else if (option === 'NetSellVol') {
    remove(hideColumnsNew, function(n) {
      return n === 'foreignSellVolume';
    });
  } else if (option === 'NetSellVal') {
    remove(hideColumnsNew, function(n) {
      return n === 'foreignSellValue';
    });
  }

  return hideColumnsNew;
};

const computedGetHideColumns = memoize(getHideColumns);

function TableOverViewForeign(props) {
  const { listId, isLoading, option, sortState, changeSortState } = props;
  return (
    <Table
      sortState={sortState}
      onSort={changeSortState}
      listId={listId}
      isLoading={isLoading}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      getDataFromRedux={getDataFromRedux}
      hideColumns={computedGetHideColumns(option)}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.overview.overviewTopForeignTradeHeader"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopForeignTradeTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    option: state[REDUCER_NAME].option,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableOverViewForeign);
